<template>
  <UiButtonIcon
    v-if="sortField"
    class="jps-search-sorter"
    tag="button"
    :arialabel="label"
    @click="sort()"
    :icon="icon"
  />
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'

interface Props {
  isItem?: boolean
  field?: string
  ss: SearchStore<any>
}
const props = withDefaults(defineProps<Props>(), {
  isItem: false
})

const label = computed(() => {
  return 'toggle sort ' + sortField.value
})

const sortField = computed(() => {
  if (props.field) {
    if (props.isItem) {
      if (props.field === 'common.title') {
        return 'sindex.sortTitle'
      } else if (props.field === 'common.temporal') {
        return 'sindex.sortTemporal'
      } else if (props.field === 'common.contributor') {
        return 'sindex.sortContributor'
      }
      if (props.field.endsWith('-s')) {
        return props.field + '.keyword'
      }
    } else {
      return props.field
    }
  }
  return null
})

// "asc"|"desc"|"none"
const status = computed(() => {
  if (props.ss && props.ss.state.sort) {
    let fieldSort = props.ss.state.sort.find(
      s => s.split(':')[0] === sortField.value,
    )
    if (fieldSort != null) {
      return fieldSort.split(':')[1]
    }
  }
  return 'none'
})

const icon = computed<SVG_NAMES>(() => {
  if (status.value === 'asc') {
    return 'mdi/sort-ascending'
  } else if (status.value === 'desc') {
    return 'mdi/sort-descending'
  } else {
    return 'mdi/sort-variant'
  }
})

const sort = () => {
  let newSort = []
  if (status.value === 'asc') {
    newSort.unshift(sortField.value + ':desc')
  } else if (status.value === 'desc' || status.value === 'none') {
    newSort.unshift(sortField.value + ':asc')
  }
  props.ss.setSort(newSort)
}
</script>
